// contexts/SocketContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { io } from "socket.io-client";

const SocketCtx = createContext(null);

export function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return; // sem token, sem socket

    const fallbackOrigin = window.location.origin.includes("localhost")
      ? "http://localhost:3000"
      : window.location.origin;
    const base =
      process.env.REACT_APP_API_URL ||
      process.env.REACT_APP_SOCKET_URL ||
      fallbackOrigin;
    const s = io(base, {
      path: "/socket.io",
      auth: { token },
      transports: ["websocket"],
      withCredentials: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 600,
      reconnectionDelayMax: 6000,
    });

    socketRef.current = s;

    const onConnect = () => {
      setReady(true);
      // logs úteis de diagnóstico
      console.debug("[socket] connected", s.id);
    };
    const onErr = (e) =>
      console.warn("[socket] connect_error:", e?.message || e);
    const onDisc = (r) => console.warn("[socket] disconnected:", r);

    s.on("connect", onConnect);
    s.on("connect_error", onErr);
    s.on("disconnect", onDisc);

    return () => {
      try {
        s.off("connect", onConnect);
        s.off("connect_error", onErr);
        s.off("disconnect", onDisc);
        s.disconnect();
      } catch {}
      socketRef.current = null;
      setReady(false);
    };
  }, []);

  const value = useMemo(() => ({ socketRef, ready }), [ready]);

  return (
    <SocketCtx.Provider value={value}>
      {children}
    </SocketCtx.Provider>
  );
}

export function useSocketRef() {
  const ctx = useContext(SocketCtx);
  return ctx?.socketRef ?? { current: null };
}
export function useSocketReady() {
  const ctx = useContext(SocketCtx);
  return !!ctx?.ready;
}
